package com.mrpowergamerbr.puppydough.webrune

import kotlinx.serialization.Serializable

@Serializable
data class WebruneConfig(
    val versions: List<GameVersion>,
    val activeVersion: String?
) {
    @Serializable
    data class GameVersion(
        val id: String,
        val name: String,
        val gameWADName: String
    )
}